import { cn } from 'utils/utils';
import {
  Clock,
  LoaderCircle,
  CircleSlash2,
  CircleAlert,
  ClipboardX,
  Truck,
  CircleParking,
  PackageCheck,
} from 'lucide-react';
// import { useTranslation } from '@/hooks/useTranslation';

export type InvoiceStatus =
  | 'pendente'
  | 'aguardando'
  | 'processando'
  | 'cancelado'
  | 'iniciado'
  | 'chegada'
  | 'liberado'
  | 'no-show'
  | 'rejeitado';

export type InvoiceStatusIconProps = {
  status: InvoiceStatus;
  size?: 'small' | 'large';
};

type StatusBaseProps = {
  children: React.ReactNode;
} & React.HTMLAttributes<HTMLSpanElement>;

export function InvoiceStatusIcon({ status, size }: InvoiceStatusIconProps) {
  const StatusBase = ({ children, className }: StatusBaseProps) => {
    return (
      <span
        title={status.toUpperCase()}
        className={cn(
          'rounded-full bg-slate-300 text-slate-50 flex items-center justify-center p-1',
          size === 'large' ? 'w-10 h-10' : 'w-8 h-8',
          className
        )}
      >
        {children}
      </span>
    );
  };
  const renderIcon = (status: InvoiceStatus) => {
    switch (status) {
      case 'liberado':
        return (
          <StatusBase className="bg-green-600">
            <PackageCheck size={20} />
          </StatusBase>
        );
      case 'chegada':
        return (
          <StatusBase className="bg-yellow-500">
            <CircleParking size={20} />
          </StatusBase>
        );
      case 'iniciado':
        return (
          <StatusBase className="bg-purple-400">
            <Truck size={20} />
          </StatusBase>
        );
      case 'no-show':
        return (
          <StatusBase className="bg-orange-600">
            <ClipboardX size={20} />
          </StatusBase>
        );
      case 'pendente':
        return (
          <StatusBase className="bg-amber-400">
            <CircleAlert />
          </StatusBase>
        );
      case 'aguardando':
        return (
          <StatusBase className="bg-blue-500">
            <Clock />
          </StatusBase>
        );
      case 'processando':
        return (
          <StatusBase className="bg-orange-500">
            <LoaderCircle />
          </StatusBase>
        );
      case 'cancelado':
        return (
          <StatusBase className="bg-red-500">
            <CircleSlash2 />
          </StatusBase>
        );
      case 'rejeitado':
        return (
          <StatusBase className="bg-red-500">
            <CircleSlash2 />
          </StatusBase>
        );
      default:
        return (
          <StatusBase>
            <></>
          </StatusBase>
        );
    }
  };
  return (
    <div className="flex items-center justify-center">{renderIcon(status)}</div>
  );
}
